import type { ReactNode } from "react"
import { Tag } from "./Tag"

interface Props {
  children: ReactNode
  icon?: ReactNode
  className?: string
}

const MetadataTag = ({ children, icon, className }: Props) => {
  return (
    <Tag variant="lightBlue" icon={icon} className={className}>
      {children}
    </Tag>
  )
}

MetadataTag.displayName = "MetadataTag"

export { MetadataTag }
export default MetadataTag
